export default "__VITE_ASSET__DtWjg8Ct__"